import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const alertTheme = createTheme(shippoTheme, {
    components: {
        MuiAlert: {
            styleOverrides: {
                root: {
                    padding: shippoTheme.spacing(2),
                    display: 'grid',
                    gap: shippoTheme.spacing(1),
                    gridTemplateColumns: 'auto 1fr',
                    width: 'auto',
                    justifyContent: 'flex-start',
                    zIndex: 2,
                    borderRadius: '8px',
                    '& .MuiAlert-message .MuiAlertTitle-root': {
                        color: colors.text.default,
                        fontWeight: 500,
                        lineHeight: '150%',
                        fontStyle: 'normal',
                    },
                    '& .MuiAlert-message': {
                        padding: 0,
                        fontSize: shippoTheme.spacing(2),
                        color: colors.text.default,
                        fontWeight: 400,
                        lineHeight: '150%',
                        fontStyle: 'normal',
                        '& a': {
                            color: colors.text.default,
                        },
                    },
                    '& .MuiAlert-icon': {
                        display: 'flex',
                        alignSelf: 'flex-start',
                        marginRight: 0,
                        padding: 0,
                    },
                    '& .MuiAlert-action': {
                        gridColumn: 'span 2',
                        justifyContent: 'center',
                        width: '100%',
                        padding: 0,
                        '& .MuiButton-root': {
                            color: colors.secondary,
                            fontSize: shippoTheme.spacing(2),
                            fontStyle: 'normal',
                            fontWeight: 500,
                            lineHeight: '150%',
                        },
                    },
                },
                standardInfo: {
                    backgroundColor: colors.accent.background.informational,
                    '& .MuiAlert-icon': {
                        color: colors.accent.foreground.informational,
                    },
                    '& .MuiAlertTitle-root': {
                        color: colors.accent.foreground.informational,
                    },
                },
                standardSuccess: {
                    backgroundColor: colors.accent.background.success,
                    '& .MuiAlert-icon': {
                        color: colors.accent.foreground.success,
                    },
                    '& .MuiAlertTitle-root': {
                        color: colors.accent.foreground.success,
                    },
                },
                standardError: {
                    backgroundColor: colors.accent.background.error,
                    '& .MuiAlert-icon': {
                        color: colors.accent.foreground.error,
                    },
                    '& .MuiAlertTitle-root': {
                        color: colors.accent.foreground.error,
                    },
                },
                standardWarning: {
                    backgroundColor: colors.accent.background.warning,
                    '& .MuiAlert-icon': {
                        color: colors.accent.foreground.warning,
                    },
                    '& .MuiAlertTitle-root': {
                        color: colors.accent.foreground.warning,
                    },
                },
            },
        },
    },
});

export { alertTheme as default };
//# sourceMappingURL=Alert.theme.js.map
